import { useEffect, useState, useCallback } from 'react'

import Loading from '../Loading'
import ItemsType from '../loops/itemsType'
import { Get_Purchased } from '../../api/api'
import axios from 'axios'
import { useParams, useSearchParams } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller';
import ItemsTypePurchased from '../loops/itemsTypePurchased'

export default function PurchasedItem() {


  const [loading, setLoading] = useState(true)
  const [item, setItem] = useState([])

  const [notFound, setNotFound] = useState(false)
  const [isError, setIsError] = useState(false)

  const [pageNum, setPageNum] = useState(1)
  const [fetching, setFetching] = useState(false)


  const params = useParams()
  const [searchParams] = useSearchParams();

  const [param, setParam] = useState(params.typeId)


  useEffect(() => {
    setParam(params.typeId)
    setItem([])
    setNotFound(false)
    setPageNum(1)
    setLoading(true)

  }, [params, param, searchParams])


  //loadmore

  const fetchItems = useCallback(
    async () => {
      if (fetching || isError) {
        return;
      }

      setFetching(true);

      try {
        setLoading(true)
        const res = await axios.get(Get_Purchased(pageNum))

        setItem([...item, ...res.data])
        res.data != '' ? setPageNum(pageNum + 1) : setPageNum(null)
        res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)
      } catch (err) {
        setIsError(true)

      } finally {
        setFetching(false)
        setLoading(false)

      }

    },


    [item, fetching, pageNum]
  );

  const hasMoreItems = !!pageNum;
  //loadmore




  return (
    <>
      <div className='contentHolder'>
        <InfiniteScroll
          loadMore={fetchItems}
          hasMore={hasMoreItems}
          loader={<Loading key={pageNum} styles={'mini'} />}
        >

          <div className="contentHolder">
            <ItemsTypePurchased data={item} />
          </div>

        </InfiniteScroll>

        {notFound ? (<p style={{ textAlign: 'center' }}>شما تاکنون هیچ خریدی ثبت نکرده اید!</p>) : ''}
      </div>
    </>
  )
}
